import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      id: undefined,
      username: undefined,
      password: undefined,
      email: undefined,
      role: undefined
    }
  },
  mutations,
  actions,
  getters
}
